$( document ).ready(function() {
    $( document ).on('click', '.number-input__button', function(e){
        e.preventDefault();
        var numberInput = $(this).parent().find('.number-input');

        var oldValue = parseInt(numberInput.val());
        if($(this).hasClass('number-input__button--plus')){
            numberInput.val(oldValue + 1);
        }
        if($(this).hasClass('number-input__button--minus')){
            numberInput.val(oldValue == 1 ? 1 : oldValue - 1);
        }
        numberInput.trigger("change");
    });
});

function textfieldAppearance(input) {
    input.css('-moz-appearance', 'textfield');
}
